// Small wrapper around `window.dataLayer.push` used by public form
// submission handlers. The bootstrap in `public/index.html` ensures
// `window.dataLayer` exists before React mounts, but we still guard
// against server-side rendering / test contexts where `window` may be
// undefined.

export const pushDataLayerEvent = (event, payload = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  try {
    window.dataLayer.push({ event, ...payload });
  } catch {
    // Never let analytics break the UI.
  }
};

// Named helper for the "form submitted successfully" event so every
// caller uses the exact same event/name pair (matches the naming
// contract configured in GTM/GA4).
export const trackFormSubmission = (formName, extra = {}) => {
  pushDataLayerEvent('form_submission', { form_name: formName, ...extra });
};
